import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "../pages/AccountStyles";
import { Field, reduxForm } from "redux-form";
import SuccessMessage from "../components/SuccessMessage";
import ErrorMessage from "../components/ErrorMessage";
import { connect } from "react-redux";

const validate = (values) => {
  const errors = {};
  if (!values.password) {
    errors.password = "Your current password is required";
  }
  if (
    !/(.[~!@#$%^&*_\-+=\`|\\(){}[\]:;\“\"\’\'\<\>,.?])/.test(values.newPassword)
  ) {
    errors.newPassword = "Your password must contain a special character.";
  }
  if (/^\d+$/.test(values.newPassword)) {
    errors.newPassword =
      "This password is entirely numeric. Please add at least 1 character.";
  }
  if (values.newPassword && values.newPassword.length < 8) {
    errors.newPassword =
      "This password is too short. It must contain at least 8 characters.";
  }
  if (!/[a-z]/.test(values.newPassword)) {
    errors.newPassword = "Your password must contain a lowercase letter.";
  }
  if (!/[A-Z]/.test(values.newPassword)) {
    errors.newPassword = "Your password must contain an uppercase letter.";
  }
  if (!values.newPassword) {
    errors.newPassword = "Your new password is required";
  }
  if (!values.verifyPassword) {
    errors.newPassword = "Type your new password";
  }
  if (values.newPassword && values.newPassword !== values.verifyPassword) {
    errors.newPassword = "Your new passwords do not match";
  }
  if (values.password === values.newPassword) {
    errors.newPassword = "Your new and current password are the same";
  }
  return errors;
};

const renderField = (props) => {
  const {
    input,
    label,
    type,
    meta: { touched, error, warning },
  } = props;

  const inputStyles = css([
    styles.input,
    touched && error && styles.inputError,
  ]);
  return (
    <div>
      <label className={css(styles.label)}>{label}</label>
      <div>
        <input
          {...input}
          placeholder={label}
          type={type}
          className={inputStyles}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );
};

let NewPassword = (props) => {
  const { handleSubmit, pristine, submitting, submitSucceeded } = props;

  let successfulSubmit = false;
  if (props.password.detail.code === 0) {
    successfulSubmit = true;
  }

  return (
    <div>
      {successfulSubmit && <SuccessMessage message="New password saved" />}
      {!successfulSubmit && (
        <form onSubmit={handleSubmit}>
          <div>
            <Field
              name="password"
              component={renderField}
              label="Current Password"
              type={"password"}
            />
          </div>
          <div>
            <Field
              name="newPassword"
              component={renderField}
              label="New Password"
              type={"password"}
            />
          </div>
          <div>
            <Field
              name="verifyPassword"
              component={renderField}
              label="Re-enter New Password"
              type={"password"}
            />
          </div>
          <div>
            <button
              type="submit"
              disabled={pristine || submitting}
              className={css(styles.buttonGreen)}
            >
              Save New Password
            </button>
          </div>
          {props.password.detail.code === 3 && (
            <ErrorMessage message="Current password is not correct" />
          )}
          {props.password.detail.code === 2 && (
            <ErrorMessage message="Your new password must contain a special character" />
          )}
        </form>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    password: state.password,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "new-password",
    validate,
  })(NewPassword)
);
